import { render, staticRenderFns } from "./RedeliveryRequestList.vue?vue&type=template&id=64e866e0&scoped=true&"
import script from "./RedeliveryRequestList.vue?vue&type=script&lang=js&"
export * from "./RedeliveryRequestList.vue?vue&type=script&lang=js&"
import style0 from "./RedeliveryRequestList.vue?vue&type=style&index=0&id=64e866e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e866e0",
  null
  
)

export default component.exports